import React from 'react'
import { environmentOf } from '../env/environment'

// Which environments get the notice, and the words on the tab. Production and
// any host environmentOf does not classify (a customer's own domain, a
// preview) show nothing.
const NOTICE = {
  local: { label: 'LOCAL', title: 'Local environment' },
  dev: { label: 'DEV', title: 'Development environment' }
}

// A thin coloured line across the very top of the viewport with a small tab
// hanging from its centre, so nobody mistakes local or dev for production.
// Fixed above everything, never takes a click (the header sits beneath it),
// and not printed. Colours are theme variables (scss/other.scss,
// .edxr-env-notice), one pair per environment, readable in both themes.
export const EnvironmentNotice = ({ host = window.location.host }) => {
  const env = environmentOf(host)
  const notice = NOTICE[env]
  if (!notice) return null

  return (
    <div className={`edxr-env-notice edxr-env-notice-${env}`}>
      <div className="edxr-env-notice-line" aria-hidden="true" />
      <div className="edxr-env-notice-tab" title={`${notice.title} (${host})`}>
        {notice.label}
      </div>
    </div>
  )
}
